import { Controller } from "@hotwired/stimulus"

// Manages AI wizard form interactions, including:
// - Loading state during form submission
// - Enabling/disabling submit button based on confirmation checkbox
export default class extends Controller {
  static targets = ["confirmCheckbox", "submitButton"]
  static classes = ["loading"]

  connect() {
    // Find the form element
    this.form = this.element.tagName === "FORM" ? this.element : this.element.querySelector("form")
    
    if (this.form) {
      this.form.addEventListener("submit", this.handleSubmit.bind(this))
    }
  }

  disconnect() {
    if (this.form) {
      this.form.removeEventListener("submit", this.handleSubmit.bind(this))
    }
  }

  toggleSubmit() {
    if (!this.hasConfirmCheckboxTarget || !this.hasSubmitButtonTarget) return

    const isConfirmed = this.confirmCheckboxTarget.checked
    this.submitButtonTarget.disabled = !isConfirmed
  }

  handleSubmit(event) {
    // Only show loading on final step (when confirm checkbox exists and is checked)
    if (this.hasConfirmCheckboxTarget && this.confirmCheckboxTarget.checked) {
      this.showLoading()
    }
  }

  showLoading() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.classList.add("loading", "loading-spinner")
      this.submitButtonTarget.disabled = true
    }

    // Add loading class to form if specified
    if (this.hasLoadingClass) {
      this.element.classList.add(this.loadingClass)
    }
  }
}
